import { render, staticRenderFns } from "./AdminActivateAccountDialog.vue?vue&type=template&id=771ddd8a&scoped=true"
import script from "./AdminActivateAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminActivateAccountDialog.vue?vue&type=script&lang=js"
import style1 from "./AdminActivateAccountDialog.vue?vue&type=style&index=1&id=771ddd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ddd8a",
  null
  
)

export default component.exports